import React, { useState } from 'react';
import { db, storage } from '../firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
import styles from './Admin.module.css';

const MusicAdmin = () => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [generatedLink, setGeneratedLink] = useState('');

    const handleUpload = async () => {
        if (!file) return alert("Select a file");
        setUploading(true);

        try {
            // 1. Upload to Storage
            const storageRef = ref(storage, `songs/${Date.now()}_${file.name}`);
            await uploadBytes(storageRef, file);
            const url = await getDownloadURL(storageRef);

            // 2. Save Reference to Firestore
            const docRef = await addDoc(collection(db, "secure_shares"), {
                songName: file.name,
                audioUrl: url,
                plays: 0,
                createdAt: new Date()
            });

            // 3. Create CLEAN Path Link (No question marks)
            const link = `${window.location.origin}/play/${docRef.id}`;
            setGeneratedLink(link);
        } catch (err) {
            console.error(err);
            alert("Upload Error");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className={styles.adminPage}>
            <div className={styles.uploadCard}>
                <h2>🎵 Music Admin</h2>
                <input type="file" accept="audio/*" onChange={(e) => setFile(e.target.files[0])} />
                <button onClick={handleUpload} disabled={uploading || !file} className={styles.btn}>
                    {uploading ? "Uploading..." : "Generate Restricted Link"}
                </button>

                {generatedLink && (
                    <div className={styles.linkResult}>
                        <p>Share this Link:</p>
                        <input readOnly value={generatedLink} className={styles.linkInput} />
                        <button onClick={() => navigator.clipboard.writeText(generatedLink)}>Copy</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MusicAdmin;